import { BD_PROJECT_DATA_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
    getCountriesLoading: false,
    getCountriesSuccess: false,
    getCountriesFailure: false,
    getCountriesError: null,
    countries: [],

    getWarmLeadsListLoading: false,
    getWarmLeadsListSuccess: false,
    getWarmLeadsListFailure: false,
    getWarmLeadsListError: null,
    warmLeadsList: [],

    getWarmLeadsLoading: false,
    getWarmLeadsSuccess: false,
    getWarmLeadsFailure: false,
    getWarmLeadsError: null,
    warmLeads: [],

    getBusinessPerAgentLoading: false,
    getBusinessPerAgentSuccess: false,
    getBusinessPerAgentFailure: false,
    getBusinessPerAgentError: null,
    businessPerAgent: [],

    leadsGeneratedPerAgentLoading: false,
    leadsGeneratedPerAgentSuccess: false,
    leadsGeneratedPerAgentFailure: false,
    leadsGeneratedPerAgentError: null,
    leadsGeneratedPerAgent: [],

    conversionPerAgentLoading: false,
    conversionPerAgentSuccess: false,
    conversionPerAgentFailure: false,
    conversionPerAgentError: null,
    conversionPerAgent: [],


    conversionTrendLoading: false,
    conversionTrendSuccess: false,
    conversionTrendFailure: false,
    conversionTrendError: null,
    conversionTrend: [],

    quarterlyDataLoading: false,
    quarterlyDataSuccess: false,
    quarterlyDataFailure: false,
    quarterlyDataError: null,
    quarterlyData: [],

    getStatesLoading: false,
    getStatesSuccess: false,
    getStatesFailure: false,
    getStatesError: null,
    states: [],

    getCitiesLoading: false,
    getCitiesSuccess: false,
    getCitiesFailure: false,
    getCitiesError: null,
    cities: [],

    getProjectCategoryLoading: false,
    getProjectCategorySuccess: false,
    getProjectCategoryFailure: false,
    getProjectCategoryError: null,
    projectCategory: [],
    projectSubCategory: [],

    getKeywordsLoading: false,
    getKeywordsSuccess: false,
    getKeywordsFailure: false,
    getKeywordsError: null,
    keywords: [],

    getTechKeywordsLoading: false,
    getTechKeywordsSuccess: false,
    getTechKeywordsFailure: false,
    getTechKeywordsError: null,
    techKeywords: [],

    getProjectsDataLoading: false,
    getProjectsDataSuccess: false,
    getProjectsDataFailure: false,
    getProjectsDataError: null,
    projectsData: [],

    getLeadsPerPlatformLoading: false,
    getLeadsPerPlatformSuccess: false,
    getLeadsPerPlatformFailure: false,
    getLeadsPerPlatformError: null,
    leadsPerPlatform: [],
    getProjectDataLoading: false,
    getProjectDataSuccess: false,
    getProjectDataFailure: false,
    getProjectDataError: null,
    projectData: [],

    saveProjectDataLoading: false,
    saveProjectDataSuccess: false,
    saveProjectDataFailure: false,
    saveProjectDataError: null,
    saveProjectData: [],

    deleteProjectDataLoading: false,
    deleteProjectDataSuccess: false,
    deleteProjectDataFailure: false,
    deleteProjectDataError: null,
    deleteProjectData: [],

    checkProjectEmailLoading: false,
    checkProjectEmailSuccess: false,
    checkProjectEmailFailure: false,
    checkProjectEmailError: null,
    checkProjectEmailData: null,

    checkProjectPostUrlLoading: false,
    checkProjectPostUrlSuccess: false,
    checkProjectPostUrlFailure: false,
    checkProjectPostUrlError: null,
    checkProjectPostUrlData: [],

    verifyProjectPhoneLoading: false,
    verifyProjectPhoneSuccess: false,
    verifyProjectPhoneFailure: false,
    verifyProjectPhoneError: null,
    projectPhoneData: null,

    saveProjectAgentAllocationLoading: false,
    saveProjectAgentAllocationSuccess: false,
    saveProjectAgentAllocationFailure: false,
    saveProjectAgentAllocationError: null,
    projectAgentAllocationData: [],

    deleteProjectAgentAllocationLoading: false,
    deleteProjectAgentAllocationSuccess: false,
    deleteProjectAgentAllocationFailure: false,
    deleteProjectAgentAllocationError: null,
    deleteProjectAgentAllocationData: [],

    getProjectAgentAllocationLoading: false,
    getProjectAgentAllocationSuccess: false,
    getProjectAgentAllocationFailure: false,
    getProjectAgentAllocationError: null,
    getProjectAgentAllocationData: [],

    getProjectAgentAllocationListLoading: false,
    getProjectAgentAllocationListSuccess: false,
    getProjectAgentAllocationListFailure: false,
    getProjectAgentAllocationListError: null,
    getProjectAgentAllocationListData: [],

}

export const BdProjectDataReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_REQUEST:
            return {
                ...state,
                getCountriesLoading: true,
                getCountriesSuccess: false,
                getCountriesFailure: false,
                getCountriesError: null,
                countries: []
            }
        case BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_SUCCESS:
            return {
                ...state,
                getCountriesLoading: false,
                getCountriesSuccess: true,
                getCountriesFailure: false,
                getCountriesError: null,
                countries: action.payload
            }
        case BD_PROJECT_DATA_REQUEST.GET_COUNTRIE_FAILURE:
            return {
                ...state,
                getCountriesLoading: false,
                getCountriesSuccess: false,
                getCountriesFailure: false,
                getCountriesError: action.payload,
                countries: []
            }


        /////////////
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_REQUEST:
            return {
                ...state,
                getWarmLeadsListLoading: true,
                getWarmLeadsListSuccess: false,
                getWarmLeadsListFailure: false,
                getWarmLeadsListError: null,
                warmLeadsList: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_SUCCESS:
            return {
                ...state,
                getWarmLeadsListLoading: false,
                getWarmLeadsListSuccess: true,
                getWarmLeadsListFailure: false,
                getWarmLeadsListError: null,
                warmLeadsList: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_LIST_FAILURE:
            return {
                ...state,
                getWarmLeadsListLoading: false,
                getWarmLeadsListSuccess: false,
                getWarmLeadsListFailure: true,
                getWarmLeadsListError: action.payload,
                warmLeadsList: [],
            }
        /////////////
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_REQUEST:
            return {
                ...state,
                getWarmLeadsLoading: true,
                getWarmLeadsSuccess: false,
                getWarmLeadsFailure: false,
                getWarmLeadsError: null,
                warmLeads: []
            }
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_SUCCESS:
            return {
                ...state,
                getWarmLeadsLoading: false,
                getWarmLeadsSuccess: true,
                getWarmLeadsFailure: false,
                getWarmLeadsError: null,
                warmLeads: action.payload
            }
        case BD_PROJECT_DATA_REQUEST.GET_WARM_LEADS_FAILURE:
            return {
                ...state,
                getWarmLeadsLoading: false,
                getWarmLeadsSuccess: false,
                getWarmLeadsFailure: true,
                getWarmLeadsError: action.payload,
                warmLeads: []
            }
        case BD_PROJECT_DATA_REQUEST.GET_STATE_REQUEST:
            return {
                ...state,
                getStatesLoading: true,
                getStatesSuccess: false,
                getStatesFailure: false,
                getStatesError: null,
                states: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_STATE_SUCCESS:
            return {
                ...state,
                getStatesLoading: false,
                getStatesSuccess: true,
                getStatesFailure: false,
                getStatesError: null,
                states: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_STATE_FAILURE:
            return {
                ...state,
                getStatesLoading: false,
                getStatesSuccess: false,
                getStatesFailure: false,
                getStatesError: action.payload,
                states: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_CITY_REQUEST:
            return {
                ...state,
                getCitiesLoading: true,
                getCitiesSuccess: false,
                getCitiesFailure: false,
                getCitiesError: null,
                cities: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_CITY_SUCCESS:
            return {
                ...state,
                getCitiesLoading: false,
                getCitiesSuccess: true,
                getCitiesFailure: false,
                getCitiesError: null,
                cities: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_CITY_FAILURE:
            return {
                ...state,
                getCitiesLoading: false,
                getCitiesSuccess: false,
                getCitiesFailure: false,
                getCitiesError: action.payload,
                cities: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_REQUEST:
            return {
                ...state,
                getProjectCategoryLoading: true,
                getProjectCategorySuccess: false,
                getProjectCategoryFailure: false,
                getProjectCategoryError: null,
                projectCategory: [],
                projectSubCategory: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_SUCCESS:
            return {
                ...state,
                getProjectCategoryLoading: false,
                getProjectCategorySuccess: true,
                getProjectCategoryFailure: false,
                getProjectCategoryError: null,
                projectCategory: action.payload.categories,
                projectSubCategory: action.payload.subCategories,
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_CATEGORY_FAILURE:
            return {
                ...state,
                getProjectCategoryLoading: false,
                getProjectCategorySuccess: false,
                getProjectCategoryFailure: false,
                getProjectCategoryError: action.payload,
                projectCategory: [],
                projectSubCategory: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_REQUEST:
            return {
                ...state,
                getKeywordsLoading: true,
                getKeywordsSuccess: false,
                getKeywordsFailure: false,
                getKeywordsError: null,
                keywords: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_SUCCESS:
            return {
                ...state,
                getKeywordsLoading: false,
                getKeywordsSuccess: true,
                getKeywordsFailure: false,
                getKeywordsError: null,
                keywords: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_KEYWORDS_FAILURE:
            return {
                ...state,
                getKeywordsLoading: false,
                getKeywordsSuccess: false,
                getKeywordsFailure: false,
                getKeywordsError: action.payload,
                keywords: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_REQUEST:
            return {
                ...state,
                getTechKeywordsLoading: true,
                getTechKeywordsSuccess: false,
                getTechKeywordsFailure: false,
                getTechKeywordsError: null,
                techKeywords: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_SUCCESS:
            return {
                ...state,
                getTechKeywordsLoading: false,
                getTechKeywordsSuccess: true,
                getTechKeywordsFailure: false,
                getTechKeywordsError: null,
                techKeywords: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_TECH_KEYWORDS_FAILURE:
            return {
                ...state,
                getTechKeywordsLoading: false,
                getTechKeywordsSuccess: false,
                getTechKeywordsFailure: false,
                getTechKeywordsError: action.payload,
                techKeywords: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_REQUEST:
            return {
                ...state,
                getProjectsDataLoading: true,
                getProjectsDataSuccess: false,
                getProjectsDataFailure: false,
                getProjectsDataError: null,
                projectsData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_SUCCESS:
            return {
                ...state,
                getProjectsDataLoading: false,
                getProjectsDataSuccess: true,
                getProjectsDataFailure: false,
                getProjectsDataError: null,
                projectsData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECTS_DATA_FAILURE:
            return {
                ...state,
                getProjectsDataLoading: false,
                getProjectsDataSuccess: false,
                getProjectsDataFailure: false,
                getProjectsDataError: action.payload,
                projectsData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_REQUEST:
            return {
                ...state,
                getProjectDataLoading: true,
                getProjectDataSuccess: false,
                getProjectDataFailure: false,
                getProjectDataError: null,
                projectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                getProjectDataLoading: false,
                getProjectDataSuccess: true,
                getProjectDataFailure: false,
                getProjectDataError: null,
                projectData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_DATA_FAILURE:
            return {
                ...state,
                getProjectDataLoading: false,
                getProjectDataSuccess: false,
                getProjectDataFailure: false,
                getProjectDataError: action.payload,
                projectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.CLEAR_PROJECT_DATA:
            return {
                ...state,
                projectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_REQUEST:
            return {
                ...state,
                saveProjectDataLoading: true,
                saveProjectDataSuccess: false,
                saveProjectDataFailure: false,
                saveProjectDataError: null,
                saveProjectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                saveProjectDataLoading: false,
                saveProjectDataSuccess: true,
                saveProjectDataFailure: false,
                saveProjectDataError: null,
                saveProjectData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_DATA_FAILURE:
            return {
                ...state,
                saveProjectDataLoading: false,
                saveProjectDataSuccess: false,
                saveProjectDataFailure: false,
                saveProjectDataError: action.payload,
                saveProjectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_REQUEST:
            return {
                ...state,
                deleteProjectDataLoading: true,
                deleteProjectDataSuccess: false,
                deleteProjectDataFailure: false,
                deleteProjectDataError: null,
                deleteProjectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_SUCCESS:
            return {
                ...state,
                deleteProjectDataLoading: false,
                deleteProjectDataSuccess: true,
                deleteProjectDataFailure: false,
                deleteProjectDataError: null,
                deleteProjectData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_DATA_FAILURE:
            return {
                ...state,
                deleteProjectDataLoading: false,
                deleteProjectDataSuccess: false,
                deleteProjectDataFailure: false,
                deleteProjectDataError: action.payload,
                deleteProjectData: [],
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_REQUEST:
            return {
                ...state,
                checkProjectEmailLoading: true,
                checkProjectEmailSuccess: false,
                checkProjectEmailFailure: false,
                checkProjectEmailError: null,
                checkProjectEmailData: null,
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_SUCCESS:
            return {
                ...state,
                checkProjectEmailLoading: false,
                checkProjectEmailSuccess: true,
                checkProjectEmailFailure: false,
                checkProjectEmailError: null,
                checkProjectEmailData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_EMAIL_FAILURE:
            return {
                ...state,
                checkProjectEmailLoading: false,
                checkProjectEmailSuccess: false,
                checkProjectEmailFailure: false,
                checkProjectEmailError: action.payload,
                checkProjectEmailData: null,
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_REQUEST:
            return {
                ...state,
                checkProjectPostUrlLoading: true,
                checkProjectPostUrlSuccess: false,
                checkProjectPostUrlFailure: false,
                checkProjectPostUrlError: null,
                checkProjectPostUrlData: [],
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_SUCCESS:
            return {
                ...state,
                checkProjectPostUrlLoading: false,
                checkProjectPostUrlSuccess: true,
                checkProjectPostUrlFailure: false,
                checkProjectPostUrlError: null,
                checkProjectPostUrlData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.CHECK_PROJECT_POST_URL_FAILURE:
            return {
                ...state,
                checkProjectPostUrlLoading: false,
                checkProjectPostUrlSuccess: false,
                checkProjectPostUrlFailure: false,
                checkProjectPostUrlError: action.payload,
                checkProjectPostUrlData: [],
            }
        case BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_REQUEST:
            return {
                ...state,
                verifyProjectPhoneLoading: true,
                verifyProjectPhoneSuccess: false,
                verifyProjectPhoneFailure: false,
                verifyProjectPhoneError: null,
                projectPhoneData: null,
            }
        case BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_SUCCESS:
            return {
                ...state,
                verifyProjectPhoneLoading: false,
                verifyProjectPhoneSuccess: true,
                verifyProjectPhoneFailure: false,
                verifyProjectPhoneError: null,
                projectPhoneData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.VERIFY_PROJECT_PHONE_FAILURE:
            return {
                ...state,
                verifyProjectPhoneLoading: false,
                verifyProjectPhoneSuccess: false,
                verifyProjectPhoneFailure: false,
                verifyProjectPhoneError: action.payload,
                projectPhoneData: null,
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_REQUEST:
            return {
                ...state,
                saveProjectAgentAllocationLoading: true,
                saveProjectAgentAllocationSuccess: false,
                saveProjectAgentAllocationFailure: false,
                saveProjectAgentAllocationError: null,
                projectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_SUCCESS:
            return {
                ...state,
                saveProjectAgentAllocationLoading: false,
                saveProjectAgentAllocationSuccess: true,
                saveProjectAgentAllocationFailure: false,
                saveProjectAgentAllocationError: null,
                projectAgentAllocationData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.SAVE_PROJECT_AGENT_ALLOCATION_FAILURE:
            return {
                ...state,
                saveProjectAgentAllocationLoading: false,
                saveProjectAgentAllocationSuccess: false,
                saveProjectAgentAllocationFailure: false,
                saveProjectAgentAllocationError: action.payload,
                projectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_REQUEST:
            return {
                ...state,
                deleteProjectAgentAllocationLoading: true,
                deleteProjectAgentAllocationSuccess: false,
                deleteProjectAgentAllocationFailure: false,
                deleteProjectAgentAllocationError: null,
                deleteProjectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_SUCCESS:
            return {
                ...state,
                deleteProjectAgentAllocationLoading: false,
                deleteProjectAgentAllocationSuccess: true,
                deleteProjectAgentAllocationFailure: false,
                deleteProjectAgentAllocationError: null,
                deleteProjectAgentAllocationData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.DELETE_PROJECT_AGENT_ALLOCATION_FAILURE:
            return {
                ...state,
                deleteProjectAgentAllocationLoading: false,
                deleteProjectAgentAllocationSuccess: false,
                deleteProjectAgentAllocationFailure: false,
                deleteProjectAgentAllocationError: action.payload,
                deleteProjectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_REQUEST:
            return {
                ...state,
                getProjectAgentAllocationLoading: true,
                getProjectAgentAllocationSuccess: false,
                getProjectAgentAllocationFailure: false,
                getProjectAgentAllocationError: null,
                getProjectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_SUCCESS:
            return {
                ...state,
                getProjectAgentAllocationLoading: false,
                getProjectAgentAllocationSuccess: true,
                getProjectAgentAllocationFailure: false,
                getProjectAgentAllocationError: null,
                getProjectAgentAllocationData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_FAILURE:
            return {
                ...state,
                getProjectAgentAllocationLoading: false,
                getProjectAgentAllocationSuccess: false,
                getProjectAgentAllocationFailure: false,
                getProjectAgentAllocationError: action.payload,
                getProjectAgentAllocationData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_REQUEST:
            return {
                ...state,
                getProjectAgentAllocationListLoading: true,
                getProjectAgentAllocationListSuccess: false,
                getProjectAgentAllocationListFailure: false,
                getProjectAgentAllocationListError: null,
                getProjectAgentAllocationListData: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_SUCCESS:
            return {
                ...state,
                getProjectAgentAllocationListLoading: false,
                getProjectAgentAllocationListSuccess: true,
                getProjectAgentAllocationListFailure: false,
                getProjectAgentAllocationListError: null,
                getProjectAgentAllocationListData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_PROJECT_AGENT_ALLOCATION_LIST_FAILURE:
            return {
                ...state,
                getProjectAgentAllocationListLoading: false,
                getProjectAgentAllocationListSuccess: false,
                getProjectAgentAllocationListFailure: false,
                getProjectAgentAllocationListError: action.payload,
                getProjectAgentAllocationListData: [],
            }

        case BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_REQUEST:
            return {
                ...state,
                getLeadsPerPlatformLoading: true,
                getLeadsPerPlatformSuccess: false,
                getLeadsPerPlatformFailure: false,
                getLeadsPerPlatformError: null,
                leadsPerPlatform: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_SUCCESS:
            return {
                ...state,
                getLeadsPerPlatformLoading: false,
                getLeadsPerPlatformSuccess: true,
                getLeadsPerPlatformFailure: false,
                getLeadsPerPlatformError: null,
                leadsPerPlatform: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_LEADS_PER_PLATFORM_FAILURE:
            return {
                ...state,
                getLeadsPerPlatformLoading: false,
                getLeadsPerPlatformSuccess: false,
                getLeadsPerPlatformFailure: true,
                getLeadsPerPlatformError: action.payload,
                leadsPerPlatform: []
            }
        case BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_REQUEST:
            return {
                ...state,
                getBusinessPerAgentLoading: true,
                getBusinessPerAgentSuccess: false,
                getBusinessPerAgentFailure: false,
                getBusinessPerAgentError: null,
                businessPerAgent: [],
            }
        case BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_SUCCESS:
            return {
                ...state,
                getBusinessPerAgentLoading: false,
                getBusinessPerAgentSuccess: true,
                getBusinessPerAgentFailure: false,
                getBusinessPerAgentError: null,
                businessPerAgent: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.GET_BUSINESS_PER_AGENT_FAILURE:
            return {
                ...state,
                getBusinessPerAgentLoading: false,
                getBusinessPerAgentSuccess: false,
                getBusinessPerAgentFailure: true,
                getBusinessPerAgentError: action.payload,
                businessPerAgent: [],
            }

        case BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_REQUEST:
            return {
                ...state,
                leadsGeneratedPerAgentLoading: true,
                leadsGeneratedPerAgentSuccess: false,
                leadsGeneratedPerAgentFailure: false,
                leadsGeneratedPerAgentError: null,
                leadsGeneratedPerAgent: [],
            }
        case BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_SUCCESS:
            return {
                ...state,
                leadsGeneratedPerAgentLoading: false,
                leadsGeneratedPerAgentSuccess: true,
                leadsGeneratedPerAgentFailure: false,
                leadsGeneratedPerAgentError: null,
                leadsGeneratedPerAgent: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.LEADS_GENERATED_PER_AGENT_FAILURE:
            return {
                ...state,
                leadsGeneratedPerAgentLoading: false,
                leadsGeneratedPerAgentSuccess: false,
                leadsGeneratedPerAgentFailure: true,
                leadsGeneratedPerAgentError: action.payload,
                leadsGeneratedPerAgent: [],
            }

        //////////////////////
        case BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_REQUEST:
            return {
                ...state,
                conversionPerAgentLoading: true,
                conversionPerAgentSuccess: false,
                conversionPerAgentFailure: false,
                conversionPerAgentError: null,
                conversionPerAgent: [],
            }
        case BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_SUCCESS:
            return {
                ...state,
                conversionPerAgentLoading: false,
                conversionPerAgentSuccess: true,
                conversionPerAgentFailure: false,
                conversionPerAgentError: null,
                conversionPerAgent: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.CONVERSION_PER_AGENT_FAILURE:
            return {
                ...state,
                conversionPerAgentLoading: false,
                conversionPerAgentSuccess: false,
                conversionPerAgentFailure: true,
                conversionPerAgentError: action.payload,
                conversionPerAgent: [],
            }


        //////////////////////
        case BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_REQUEST:
            return {
                ...state,
                conversionTrendLoading: true,
                conversionTrendSuccess: false,
                conversionTrendFailure: false,
                conversionTrendError: null,
                conversionTrend: [],
            }
        case BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_SUCCESS:
            return {
                ...state,
                conversionTrendLoading: false,
                conversionTrendSuccess: true,
                conversionTrendFailure: false,
                conversionTrendError: null,
                conversionTrend: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.CONVERSION_TREND_FAILURE:
            return {
                ...state,
                conversionTrendLoading: false,
                conversionTrendSuccess: false,
                conversionTrendFailure: true,
                conversionTrendError: action.payload,
                conversionTrend: [],
            }

        //////////////////////
        case BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_REQUEST:
            return {
                ...state,
                quarterlyDataLoading: false,
                quarterlyDataSuccess: false,
                quarterlyDataFailure: false,
                quarterlyDataError: null,
                quarterlyData: [],
            }
        case BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_SUCCESS:
            return {
                ...state,
                quarterlyDataLoading: false,
                quarterlyDataSuccess: false,
                quarterlyDataFailure: false,
                quarterlyDataError: null,
                quarterlyData: action.payload,
            }
        case BD_PROJECT_DATA_REQUEST.QUARTERLY_DATA_FAILURE:
            return {
                ...state,
                quarterlyDataLoading: false,
                quarterlyDataSuccess: false,
                quarterlyDataFailure: false,
                quarterlyDataError: action.payload,
                quarterlyData: [],
            }



        default:
            return state
    }
}